/*******************************
 * Letters vs Phonemes Rule
*******************************/
import Rule from '../Rule';
import { ruleInputTypes, ruleTypes } from '../../../constants';
import {buildLogForRule} from '../../../utils/logUtils';

export default class LettersVsPhonemesRule extends Rule {
  constructor(logic) {
    super([ruleInputTypes.word_NLET, ruleInputTypes.word_NPHON],logic);
    this.ruleType = ruleTypes.LETTERS_VS_PHONEMES;
  }
}